import { render, staticRenderFns } from "./BrbSwitch.vue?vue&type=template&id=06f580f8&"
import script from "./BrbSwitch.vue?vue&type=script&lang=js&"
export * from "./BrbSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f580f8')) {
      api.createRecord('06f580f8', component.options)
    } else {
      api.reload('06f580f8', component.options)
    }
    module.hot.accept("./BrbSwitch.vue?vue&type=template&id=06f580f8&", function () {
      api.rerender('06f580f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbSwitch.vue"
export default component.exports